import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  DepartmentMasterCreateBulkRequestDTO,
  DepartmentMasterCreateRequestDTO,
  DepartmentMasterDeleteRequestDTO,
  DepartmentMasterDTO,
  DepartmentMasterList,
  DepartmentMasterReadAllPaginatedRequestDTO,
  DepartmentMasterReadByHospitalIdRequestDTO,
  DepartmentMasterReadByIdRequestDTO,
  DepartmentMasterUpdateRequestDTO,
} from "./hospital-department.interface";
import {
  DepartmentMaster_Create,
  DepartmentMaster_CreateBulk,
  DepartmentMaster_Delete,
  DepartmentMaster_ReadAll,
  DepartmentMaster_ReadAllPaginated,
  DepartmentMaster_ReadByHospitalId,
  DepartmentMaster_ReadByHospitalId_External,
  DepartmentMaster_ReadById,
  DepartmentMaster_Update,
} from "src/app/GlobalVariable/Hospital.GlobalVariable";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DepartmentMasterService {
  http = inject(HttpClient);

  DepartmentMaster_Create(
    data: DepartmentMasterCreateRequestDTO
  ): Observable<DepartmentMasterDTO> {
    return this.http.post<DepartmentMasterDTO>(
      DepartmentMaster_Create,
      data
    );
  }

  DepartmentMaster_ReadAll(): Observable<DepartmentMasterList> {
    return this.http.get<DepartmentMasterList>(
      DepartmentMaster_ReadAll
    );
  }

  DepartmentMaster_ReadByHospitalId(
    data: DepartmentMasterReadByHospitalIdRequestDTO
  ): Observable<DepartmentMasterList> {
    return this.http.post<DepartmentMasterList>(
      DepartmentMaster_ReadByHospitalId,
      data
    );
  }

  DepartmentMaster_ReadByHospitalId_External(
    data: DepartmentMasterReadByHospitalIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<DepartmentMasterList> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set("X-Api-Key", xApiKey)
        .set("X-Api-Timestamp", xApiTimestamp || "")
        .set("X-Api-Nonce", xApiNonce || "")
        .set("X-Api-Signature", xApiSignature);
    }
    return this.http.post<DepartmentMasterList>(
      DepartmentMaster_ReadByHospitalId_External,
      data,
      { headers }
    );
  }

  DepartmentMaster_ReadAllPaginated(
    data: DepartmentMasterReadAllPaginatedRequestDTO
  ): Observable<DepartmentMasterList> {
    return this.http.post<DepartmentMasterList>(
      DepartmentMaster_ReadAllPaginated,
      data
    );
  }

  DepartmentMaster_ReadById(
    data: DepartmentMasterReadByIdRequestDTO
  ): Observable<DepartmentMasterDTO> {
    return this.http.post<DepartmentMasterDTO>(
      DepartmentMaster_ReadById,
      data
    );
  }

  DepartmentMaster_Update(
    data: DepartmentMasterUpdateRequestDTO
  ): Observable<DepartmentMasterDTO> {
    return this.http.post<DepartmentMasterDTO>(
      DepartmentMaster_Update,
      data
    );
  }

  DepartmentMaster_Delete(
    data: DepartmentMasterDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(
      DepartmentMaster_Delete,
      data
    );
  }

  DepartmentMaster_CreateBulk(data: DepartmentMasterCreateBulkRequestDTO): Observable<DepartmentMasterList> {
    return this.http.post<DepartmentMasterList>(DepartmentMaster_CreateBulk, data);
  }
}
